"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConjunctionOperator = void 0;
var ConjunctionOperator;
(function (ConjunctionOperator) {
    ConjunctionOperator["AND"] = "$and";
    ConjunctionOperator["OR"] = "$or";
})(ConjunctionOperator = exports.ConjunctionOperator || (exports.ConjunctionOperator = {}));
//# sourceMappingURL=ConjunctionOperator.js.map